import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

function AnalyticsPageTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView();
  }, [pathname, search]);

  return null;
}

export default AnalyticsPageTracker;
